// Mock data for Elysian Evenings

export const experiences = [
  {
    id: 1,
    title: "Bollywood Awards Night",
    description: "A glamorous evening celebrating cinema with red carpet elegance, live performances, and star-studded entertainment that transforms your conference into an unforgettable awards ceremony.",
    image: "https://images.unsplash.com/photo-1766532776224-8ba87deee795?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHw0fHxib2xseXdvb2QlMjBzdGFnZXxlbnwwfHx8fDE3NzQwNzUyNzF8MA&ixlib=rb-4.1.0&q=85",
    highlights: ["Red Carpet Setup", "Live Performances", "Award Ceremonies", "Celebrity-style Entertainment"]
  },
  {
    id: 2,
    title: "Sufi & Serenity Night",
    description: "An enchanting spiritual journey through traditional Sufi music and mystical performances, creating an atmosphere of peace and cultural richness for your guests.",
    image: "https://images.unsplash.com/photo-1763044939313-0cb814a4e69e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxzdWZpJTIwcGVyZm9ybWFuY2V8ZW58MHx8fHwxNzc0MDc1Mjc2fDA&ixlib=rb-4.1.0&q=85",
    highlights: ["Sufi Music Ensemble", "Whirling Dervish", "Ambient Lighting", "Cultural Elegance"]
  },
  {
    id: 3,
    title: "Retro Glam Soirée",
    description: "Step back into the golden era of 70s and 80s glamour with vintage aesthetics, disco energy, and nostalgic entertainment that brings timeless elegance to modern events.",
    image: "https://images.pexels.com/photos/6982604/pexels-photo-6982604.jpeg",
    highlights: ["Vintage Décor", "Disco & Retro Music", "Period Costumes", "Classic Entertainment"]
  },
  {
    id: 4,
    title: "Doctor's Talent Showcase",
    description: "A high-engagement format where delegates become performers—creating connection, energy, and memorable moments through interactive talent displays.",
    image: "https://images.pexels.com/photos/2247677/pexels-photo-2247677.jpeg",
    highlights: ["Stage Spotlight", "Participant Performances", "Judges Panel", "Audience Engagement"],
    tag: "Highly Interactive"
  },
  {
    id: 5,
    title: "Cinematic Stage Experience",
    description: "A choreography-led, story-driven performance that brings cinematic storytelling to the conference stage with film-style sequences and costume transitions.",
    image: "https://images.unsplash.com/photo-1762786113000-fa587fd3d69c",
    highlights: ["Film-style Sequences", "Story-based Performances", "Costume Transitions", "Cinematic Production"],
    tag: "Our Differentiator"
  },
  {
    id: 6,
    title: "Fusion Night",
    description: "A dynamic, high-energy evening blending live music, DJ sets, and performance for a powerful closing experience with crowd engagement.",
    image: "https://images.pexels.com/photos/1190298/pexels-photo-1190298.jpeg",
    highlights: ["Live DJ & Music", "Dhol & Saxophone", "Dance Floor", "High Energy Atmosphere"],
    tag: "Closing Night"
  },
  {
    id: 7,
    title: "Elegant Gala & Networking Night",
    description: "A refined, luxury evening designed for high-level networking in an elegant setting with formal seating and soft live instrumental music.",
    image: "https://images.unsplash.com/photo-1768508951126-f90917cc510e",
    highlights: ["Formal Seating", "Soft Lighting", "Live Instrumental Music", "Premium Networking"],
    tag: "Corporate Premium"
  },
  {
    id: 9,
    title: "Luxury Wedding & Private Evenings",
    description: "Bespoke experiences for exclusive gatherings, crafted with precision and style for intimate celebrations.",
    image: "https://images.unsplash.com/photo-1519167758481-83f29da8c2b6?w=800",
    highlights: ["Bespoke Design", "Exclusive Gatherings", "Precision & Style", "Intimate Celebrations"],
    tag: "Bespoke"
  },
  {
    id: 10,
    title: "Custom Curated Concepts",
    description: "Completely personalized experiences designed based on your vision, audience, and scale—tailored to perfection.",
    image: "https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?w=800",
    highlights: ["Fully Personalized", "Vision to Reality", "Audience-Focused", "Tailored Perfection"],
    tag: "Fully Custom"
  }
];

export const services = [
  {
    id: 1,
    title: "Full Entertainment Management",
    description: "End-to-end planning and execution of entertainment experiences tailored to your conference theme and audience.",
    icon: "Sparkles"
  },
  {
    id: 2,
    title: "Musical & Theme Nights",
    description: "Curated musical performances and themed evenings that create lasting memories and engagement.",
    icon: "Music"
  },
  {
    id: 3,
    title: "End-to-End Event Execution",
    description: "Complete event management from concept to completion, ensuring flawless delivery and unforgettable experiences.",
    icon: "CheckCircle"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Dr. Mohan Mantri",
    role: "Conference Organizer",
    text: "Elysian Evenings transformed ROSACON into an extraordinary experience. Their expertise in medical conference entertainment is unmatched. The evening gala was executed flawlessly, and our delegates are still talking about it!",
    company: "ROSACON Medical Conference"
  },
  {
    id: 2,
    name: "Dr. Rajesh Sharma",
    role: "President",
    text: "We've worked with Elysian Evenings for three consecutive years for our annual medical summit. Their ability to understand our audience and deliver sophisticated entertainment is exceptional. Highly recommended!",
    company: "Indian Medical Association"
  },
  {
    id: 3,
    name: "Priya Kapoor",
    role: "Corporate Events Head",
    text: "The Bollywood Awards Night they created for our annual conference was phenomenal! Seamless execution, professional team, and entertainment that had everyone engaged. Akansha and Harish's vision brought our event to life.",
    company: "Fortune 500 Tech Company"
  },
  {
    id: 4,
    name: "Amit Verma",
    role: "VP Operations",
    text: "Elysian Evenings delivered beyond expectations for our corporate retreat. The Fusion Night was high-energy, perfectly timed, and created lasting memories. Their attention to detail is remarkable.",
    company: "Leading Pharmaceutical Corporation"
  },
  {
    id: 5,
    name: "Dr. Sunita Reddy",
    role: "Event Chair",
    text: "The Sufi & Serenity Night they curated for our cardiology conference was elegant and memorable. Perfect blend of culture and sophistication. Our international delegates were mesmerized!",
    company: "National Cardiology Conference"
  },
  {
    id: 6,
    name: "Karan Mehta",
    role: "Managing Director",
    text: "We entrusted Elysian Evenings with our company's 25th anniversary celebration. The Cinematic Stage Experience was absolutely spectacular - a perfect showcase of their choreography excellence and creative vision.",
    company: "FMCG Industry Leader"
  },
  {
    id: 7,
    name: "Dr. Anil Kumar",
    role: "Conference Secretary",
    text: "Having organized medical conferences for over 15 years, I can confidently say Elysian Evenings sets a new standard. Their understanding of medical conference dynamics and ability to create appropriate entertainment is outstanding.",
    company: "All India Medical Conference"
  },
  {
    id: 8,
    name: "Neha Gupta",
    role: "Brand Manager",
    text: "The Doctor's Talent Showcase they organized for our pharma conference was brilliant! Engaging, interactive, and perfectly executed. It brought our delegates together in a way we never imagined.",
    company: "Multinational Pharma Brand"
  },
  {
    id: 9,
    name: "Vikram Singh",
    role: "CEO",
    text: "Elysian Evenings transformed our annual awards ceremony into a world-class event. Their experience with Femina Miss India and other major shows clearly reflects in their work. Absolute professionals!",
    company: "Media & Entertainment Group"
  }
];

export const contactInfo = {
  phone: "9167-176-555",
  phones: [
    { name: "Dr. Akanksha Mantri", number: "9167-176-555" },
    { name: "Harish Chand Bhatt", number: "+91 76784 65816" }
  ],
  emails: ["planyourevening@elysianevenings.in", "akansha.mantri@gmail.com", "harishbhatt21@gmail.com"],
  socialMedia: {
    instagram: "https://www.instagram.com/elysianeveningsforu/",
    linkedin: "#",
    facebook: "#",
    youtube: "http://www.youtube.com/@ElysianEvenings"
  }
};

// Gallery Categories with Images & Videos
export const galleryCategories = [
  {
    id: 'award-nights',
    name: 'Glimpse in the Award Nights',
    thumbnail: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/urxdxna6_The%2013th%20Indian%20Telly%20Awards%20b%20%28721%29.JPG',
    items: [
      {
        id: 'aw1',
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/urxdxna6_The%2013th%20Indian%20Telly%20Awards%20b%20%28721%29.JPG',
        title: 'Telly Awards Ceremony',
        category: 'Award Nights'
      },
      {
        id: 'aw2',
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/bfy9vkgr_The%2013th%20Indian%20Telly%20Awards%20b%20%28665%29.JPG',
        title: 'Telly Awards Stage',
        category: 'Award Nights'
      },
      {
        id: 'aw3',
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/rdr1cihd_The%2013th%20Indian%20Telly%20Awards%20a%20%2878%29.JPG',
        title: 'Awards Night Setup',
        category: 'Award Nights'
      },
      {
        id: 'aw4',
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/n0u83bnc_The%2013th%20Indian%20Telly%20Awards%20a%20%2820%29.JPG',
        title: 'Red Carpet Evening',
        category: 'Award Nights'
      },
      {
        id: 'aw5',
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/xkgrmsle_IMG_4051.JPG',
        title: 'Grand Awards Venue',
        category: 'Award Nights'
      },
      {
        id: 'aw6',
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/bah862vt_IMG_3735.JPG',
        title: 'Awards Ceremony Decor',
        category: 'Award Nights'
      },
      {
        id: 'aw7',
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/8n3mvmsg_IMG_3524.JPG',
        title: 'Awards Night Ambiance',
        category: 'Award Nights'
      },
      {
        id: 'aw8',
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/gy70z8sx_DSC_9437.JPG',
        title: 'Trophy Presentation',
        category: 'Award Nights'
      },
      {
        id: 'aw9',
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/ahorqv58_DSC_9294.JPG',
        title: 'Awards Stage Performance',
        category: 'Award Nights'
      },
      {
        id: 'aw10',
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/aghprinh_DSC_0525.JPG',
        title: 'Elegant Award Function',
        category: 'Award Nights'
      },
      {
        id: 'aw11',
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/wxwt6aao_DSC_0498.JPG',
        title: 'Awards Night Highlight',
        category: 'Award Nights'
      },
      {
        id: 'aw12',
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/k5iygcvh_DSC_0407.JPG',
        title: 'Celebrity Moment',
        category: 'Award Nights'
      },
      {
        id: 'aw13',
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/527sjbyz_DSC_0237.JPG',
        title: 'Grand Awards Evening',
        category: 'Award Nights'
      },
      {
        id: 'aw14',
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/owchfjd0_DSC_0177.JPG',
        title: 'Awards Reception',
        category: 'Award Nights'
      },
      {
        id: 'aw15',
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/1kb3a1q7_10001394_520022114773352_133492199_n.jpg',
        title: 'Awards Moment',
        category: 'Award Nights'
      },
      {
        id: 'aw16',
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/havvj3j3_1T8A8172.jpg',
        title: 'Awards Production',
        category: 'Award Nights'
      },
      {
        id: 'aw17',
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/yy6x4hrv_1T8A1836.jpg',
        title: 'Glamorous Awards Night',
        category: 'Award Nights'
      },
      {
        id: 'aw18',
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/o8pbbax4_1T8A0998.jpg',
        title: 'Star-Studded Awards',
        category: 'Award Nights'
      },
      {
        id: 'aw19',
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/w573d47z_00000IMG_00000_BURST20190315170658557_COVER.jpg',
        title: 'Awards Ceremony Highlight',
        category: 'Award Nights'
      }
    ]
  },
  {
    id: 'stars-on-stage',
    name: 'Stars on Stage',
    thumbnail: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/scdkgwwa_Zee%20holi%2012.03.2014%20%28381%29.JPG',
    items: [
      {
        id: 'st1',
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/scdkgwwa_Zee%20holi%2012.03.2014%20%28381%29.JPG',
        title: 'Zee Holi Celebration',
        category: 'Stars on Stage'
      },
      {
        id: 'st2',
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/mxhm9i20_Zee%20holi%2012.03.2014%20%28188%29.JPG',
        title: 'Holi Stage Performance',
        category: 'Stars on Stage'
      },
      {
        id: 'st3',
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/qfs0hvpi_Zee%20Holi%2010.03.2014%20%28250%29.JPG',
        title: 'Colorful Stage Show',
        category: 'Stars on Stage'
      },
      {
        id: 'st4',
        type: 'video',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/nyitp9u3_MVI_0143%20%281%29.MP4',
        thumbnail: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/scdkgwwa_Zee%20holi%2012.03.2014%20%28381%29.JPG',
        title: 'Live Performance Video',
        category: 'Stars on Stage'
      },
      {
        id: 'st5',
        type: 'video',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/3rnacidj_FEMINA%20MISS%20INDIA%20.mp4',
        thumbnail: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/urxdxna6_The%2013th%20Indian%20Telly%20Awards%20b%20%28721%29.JPG',
        title: 'Femina Miss India',
        category: 'Stars on Stage'
      },
      {
        id: 'st6',
        type: 'video',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/ylbqzfk7_MVI_0143.MP4',
        thumbnail: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/qfs0hvpi_Zee%20Holi%2010.03.2014%20%28250%29.JPG',
        title: 'Stage Highlights',
        category: 'Stars on Stage'
      },
      {
        id: 'st7',
        type: 'video',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/650dpxgr_MVI_0041.MP4',
        thumbnail: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/mxhm9i20_Zee%20holi%2012.03.2014%20%28188%29.JPG',
        title: 'Performance Showcase',
        category: 'Stars on Stage'
      },
      {
        id: 'st8',
        type: 'video',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/cfxjmiyn_MVI_0037.MP4',
        thumbnail: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/urxdxna6_The%2013th%20Indian%20Telly%20Awards%20b%20%28721%29.JPG',
        title: 'Live Entertainment',
        category: 'Stars on Stage'
      },
      {
        id: 'st9',
        type: 'video',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/u5kew72d_MVI_0019.MP4',
        thumbnail: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/bfy9vkgr_The%2013th%20Indian%20Telly%20Awards%20b%20%28665%29.JPG',
        title: 'Star Performance',
        category: 'Stars on Stage'
      },
      {
        id: 'st10',
        type: 'video',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/qd41q2em_Femina%20Miss%20India.MP4',
        thumbnail: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/rdr1cihd_The%2013th%20Indian%20Telly%20Awards%20a%20%2878%29.JPG',
        title: 'Femina Miss India Full Event',
        category: 'Stars on Stage'
      },
      {
        id: 'st11',
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/a68763av_Screenshot_20260325_211444_Instagram.jpg',
        title: 'Stage Moments',
        category: 'Stars on Stage'
      },
      {
        id: 'st12',
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/volu0ael_Screenshot_20260325_211322_Instagram.jpg',
        title: 'Performance Highlights',
        category: 'Stars on Stage'
      },
      {
        id: 'st13',
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/lb8svwv5_Screenshot_20260325_211028_Instagram.jpg',
        title: 'Stage Excellence',
        category: 'Stars on Stage'
      },
      {
        id: 'st14',
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/t63qqdtq_IMG_20180615_110424.jpg',
        title: 'Live Show',
        category: 'Stars on Stage'
      }
    ]
  },
  {
    id: 'medical-conferences',
    name: 'Medical Conferences',
    thumbnail: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/g1svlnkj_DSC_0143.JPG',
    items: [
      {
        id: 'mc1',
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/g1svlnkj_DSC_0143.JPG',
        title: 'Conference Stage Setup',
        category: 'Medical Conferences'
      },
      {
        id: 'mc2',
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/zlnkw581_DSC_0136.JPG',
        title: 'Medical Event Evening',
        category: 'Medical Conferences'
      },
      {
        id: 'mc3',
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/0pxotb9o_DSC_0129.JPG',
        title: 'Conference Entertainment',
        category: 'Medical Conferences'
      },
      {
        id: 'mc4',
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/z4enfm9s_DSC_0117.JPG',
        title: 'Delegate Engagement',
        category: 'Medical Conferences'
      },
      {
        id: 'mc5',
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/kri117u7_DSC_0116.JPG',
        title: 'Conference Gala Night',
        category: 'Medical Conferences'
      },
      {
        id: 'mc6',
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/kyziybfh_DSC_0113.JPG',
        title: 'Medical Summit Entertainment',
        category: 'Medical Conferences'
      },
      {
        id: 'mc7',
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/arqjzw6f_DSC_0102.JPG',
        title: 'Conference Evening Program',
        category: 'Medical Conferences'
      },
      {
        id: 'mc8',
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/36ft1n3w_DSC_0100.JPG',
        title: 'Professional Event Setup',
        category: 'Medical Conferences'
      },
      {
        id: 'mc9',
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/bhcmnx07_DSC_0079.JPG',
        title: 'Medical Conference Stage',
        category: 'Medical Conferences'
      },
      {
        id: 'mc10',
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/4kbfrdvq_DSC_0070.JPG',
        title: 'Conference Networking',
        category: 'Medical Conferences'
      },
      {
        id: 'mc11',
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/i7iu39jw_DSC_0025.JPG',
        title: 'Medical Event Production',
        category: 'Medical Conferences'
      },
      {
        id: 'mc12',
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/e17nhen1_DSC_0021.JPG',
        title: 'Conference Decor',
        category: 'Medical Conferences'
      },
      {
        id: 'mc13',
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/16lljw1x_DSC_0014.JPG',
        title: 'Medical Summit Setup',
        category: 'Medical Conferences'
      },
      {
        id: 'mc14',
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/psbp9eqx_DSC_0012.JPG',
        title: 'Conference Venue',
        category: 'Medical Conferences'
      },
      {
        id: 'mc15',
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/pnmavxcw_DSC_0008.JPG',
        title: 'Medical Event Highlight',
        category: 'Medical Conferences'
      },
      {
        id: 'mc16',
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/ltewyr13_Screenshot_20260325_211509_Instagram.jpg',
        title: 'Conference Social Media',
        category: 'Medical Conferences'
      },
      {
        id: 'mc17',
        type: 'image',
        url: 'https://customer-assets.emergentagent.com/job_elysian-evenings/artifacts/oa6l1hnz_Screenshot_20260325_211449_Instagram.jpg',
        title: 'Event Coverage',
        category: 'Medical Conferences'
      }
    ]
  }
];

// Legacy export for backward compatibility (flattened view)
export const galleryImages = galleryCategories.flatMap(cat => cat.items);
